export const DEFAULT_UI_CATEGORY_COLOR = "#7f8a90";

export const resolveAccentColor = (color?: string | null): string => {
  const normalized = color?.trim();
  return normalized && normalized.length > 0 ? normalized : DEFAULT_UI_CATEGORY_COLOR;
};
